<mat-card class="daxa-card plant-status-graph-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <div class="status-card-title">
                <span>{{ 'Fleet_health' | translate }}</span>
                <h5 class="mb-0">
                    {{ "Plant_status" | translate }}
                </h5>
            </div>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="status-chart-wrap">
            <div id="plant_status_graph"></div>
        </div>
        <div class="status-breakdown">
            <div class="is-online">
                <span></span>
                <strong>3</strong>
                <small>{{ 'Online' | translate }}</small>
            </div>
            <div class="is-abnormal">
                <span></span>
                <strong>1</strong>
                <small>{{ 'Abnormal' | translate }}</small>
            </div>
            <div class="is-offline">
                <span></span>
                <strong>1</strong>
                <small>{{ 'Offline' | translate }}</small>
            </div>
        </div>
    </mat-card-content>
</mat-card>
